export const getCollaboratorId = collaborator => (
  collaborator?.id || collaborator?.id_user || collaborator?.userId || null
)

export const getCollaboratorName = collaborator => {
  const fullName = [
    collaborator?.first_name || collaborator?.nome,
    collaborator?.last_name || collaborator?.sobrenome,
  ].filter(Boolean).join(' ').trim()

  return fullName || collaborator?.email || 'Sem nome'
}

export const normalizeCollaborator = collaborator => ({
  ...collaborator,
  id: getCollaboratorId(collaborator),
  first_name: collaborator?.first_name || collaborator?.nome || '',
  last_name: collaborator?.last_name || collaborator?.sobrenome || '',
  email: collaborator?.email || '',
})

export const normalizeCollaborators = collaborators => (
  Array.isArray(collaborators)
    ? collaborators.map(normalizeCollaborator).filter(collaborator => collaborator.id)
    : []
)

export const sortCollaborators = collaborators => (
  normalizeCollaborators(collaborators).sort((a, b) => (
    getCollaboratorName(a).localeCompare(getCollaboratorName(b), 'pt-BR', { sensitivity: 'base' })
  ))
)

export const collaboratorMatches = (collaborator, query) => {
  const normalizedQuery = String(query || '').trim().toLocaleLowerCase('pt-BR')
  if (!normalizedQuery) return true
  return [
    getCollaboratorName(collaborator),
    collaborator?.email,
    collaborator?.oab,
  ].some(value => String(value || '').toLocaleLowerCase('pt-BR').includes(normalizedQuery))
}
